import React, {
  Fragment,
  useState,
  useEffect,
  useRef,
  useLayoutEffect,
} from "react";
import styled from "styled-components";
import { View, Text, Divider, Link } from "./components";
import { graphql, Query } from "react-apollo";
import { compose } from "recompose";
import tagAlbumsQuery from "./graphql/tagAlbumsQuery";
import albumQuery from "./graphql/albumQuery";
import friendlyUrl from "slug";
import LogoSmall from "./components/LogoSmall";
import ArtistProjectOverview from "./components/Overview";
import Bio from "./Bio";
import Footer from "./Footer";
import Spinner from "./components/Spinner";
import { getProfessions } from "./helpers";
import categoriesProjects from "./categoriesProjects";
import { getHash, removeHash } from "./utilities/hash";
import AnchorLink from "react-anchor-link-smooth-scroll";
import { Consumer as ToggleOverlayMenu } from "./OverlayMenu";
import { MobileHeader } from "./App";
import MenuIcon from "./components/MenuIcon";
import CloseIcon from "./components/CloseIcon";
import { useMedia } from "use-media";
import { Redirect, useLocation } from "@reach/router";
import { Helmet } from "react-helmet";
import qs from "qs";

const offset = 110;

const Container = styled(View)`
  min-height: 100vmin;
`;

const CategoryItemsContainer = styled(View)`
  display: flex;
  justify-content: space-between;
  width: 100%;
  white-space: nowrap;
`;

const StickyHeader = styled(View)`
  position: sticky;
  top: 0;
  ${({ collapse }) => collapse && "top: -66px"};
  @media (max-height: 320px) {
    position: relative;
    top: 0;
  }
  z-index: 30;
  background-color: var(--bg-color);
  transition: background-color 400ms ease;
  background-color: ${(props) => props.bg};
`;

function Artist(props) {
  const [bg, setBG] = useState(() => {
    let para = window.document.querySelector("body");
    let compStyles = window.getComputedStyle(para);
    /*
    console.log(
      "current bg color: " + compStyles.getPropertyValue("background-color")
    );
    */
    return compStyles.getPropertyValue("background-color");
  });

  useLayoutEffect(() => {
    setBG("white");
  }, []);

  const albumData =
    props.data.allAlbums &&
    props.data.allAlbums.length > 0 &&
    props.data.allAlbums[0];

  const location = useLocation();
  const queryParams = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  });

  const artistTag = props.data.User
    ? props.data.User.tags.find((tag) => {
        return friendlyUrl(tag.name.replace("ü", "u")) === props.artist;
      })
    : null;
  const artistTagName = artistTag ? artistTag.name : null;
  // the back link should actually link to the history state...

  const tags = albumData && albumData?.tags;
  // const tag = tags && tags.find((tag) => professions.includes(tag.name));
  // const profession = tag ? tag.name : null
  if (albumData) {
    // console.log("profession ", getProfessions(albumData.tags))
  }
  const profession = albumData ? getProfessions(albumData.tags) : null;

  useEffect(() => {
    sessionStorage.setItem("whereWasI", "artist");
  }, []);

  const [inView, setInView] = useState({});

  const Header = ({ children }) => (
    <Fragment>
      <View>
        {profession &&
          profession
            .filter((p) => {
              if (!queryParams.profession) return true;
              const tagProfession = friendlyUrl(
                p.split(" Only").join("").split("&").join("")
              );
              // console.log(
              //   "HEADERPROFESSIONS",
              //   tagProfession,
              //   queryParams.profession
              // );
              return queryParams.profession.includes(tagProfession);
            })
            .map((p, index, input) => (
              <Link key={index} to={`/artists/${friendlyUrl(p)}`}>
                {p}
                {index < input.length - 1 && ` - `}
              </Link>
            ))}
      </View>

      <ToggleOverlayMenu>
        {({ toggle }) => (
          <MenuIcon
            style={{
              position: "absolute",
              left: "50%",
              top: 20,
              marginLeft: -13,
            }}
            onClick={toggle}
          />
        )}
      </ToggleOverlayMenu>

      <Text textStyle={"headline"} mt={4}>
        {artistTagName.split("Volkers").join("Völkers")}
      </Text>
      {children}
      {!artistTagName && (
        <Container pt={4} mt={4}>
          <Spinner />
        </Container>
      )}
    </Fragment>
  );

  const StickyOrNot = StickyHeader; // props.isWide ? StickyHeader : View
  const isMobile = useMedia({ maxWidth: 500 });

  if (
    (!!tags && tags?.find((tag) => tag.name === "Removed")) ||
    (!props.data.loading && !albumData)
  ) {
    return <Redirect noThrow to="/" />;
  }

  return (
    <Fragment>
      {!props.isWide && (
        <ToggleOverlayMenu>
          {({ on, toggle }) =>
            on ? (
              <CloseIcon
                style={{
                  position: "fixed",
                  top: 20,
                  right: 0,
                  left: "auto",
                  zIndex: 999,
                }}
                mr={[4, 4, 5]}
                onClick={toggle}
              />
            ) : (
              <MenuIcon
                style={{
                  position: "fixed",
                  top: 20,
                  right: 0,
                  left: "auto",
                  zIndex: 999,
                }}
                mr={[4, 4, 5]}
                onClick={toggle}
              />
            )
          }
        </ToggleOverlayMenu>
      )}
      <View>
        <StickyOrNot
          pt={props.isWide ? 4 : 0}
          pb={props.isWide ? 1 : 1}
          bg={bg}
          collapse={isMobile}
        >
          {props.isWide && <LogoSmall style={{ paddingRight: 0 }} />}
          {!artistTagName && (
            <Container pt={4} style={{ minHeight: "100vh" }}>
              <Spinner />
            </Container>
          )}
          {artistTagName && (
            <CategoriesMenu
              {...{
                artistTagName,
                Header,
                props,
                profession,
                inView,
                albumData,
                queryParams,
              }}
            />
          )}
        </StickyOrNot>

        {artistTagName && (
          <Query
            query={tagAlbumsQuery}
            fetchPolicy="cache-and-network"
            variables={{
              user: process.env.REACT_APP_WHITESPACE_USER,
              tagName: artistTagName,
            }}
          >
            {({ loading, error, data }) => {
              if (loading && !data?.allTags)
                return (
                  <Fragment>
                    <Container pt={4}>
                      <Spinner />
                    </Container>
                  </Fragment>
                );
              if (error && !data.allTags)
                return <Text>{`Error! ${error.message}`}</Text>;
              console.log("ALLTAGS", data.allTags);
              const albums = data.allTags[0]?.albums;
              if (!albums) return <Text>..no albums</Text>;

              const categoryAlbums = categoriesProjects
                .map((category) => ({
                  category,
                  albums: albums.filter((album) => {
                    // when a profession is specified as search param, only display those albums...
                    // or maybe just reorder them to the top?
                    if (!!queryParams.profession) {
                      return (
                        !!album.tags.find((tag) => tag.name === category) &&
                        !!album.tags.find((tag) => {
                          const tagProfession = friendlyUrl(
                            tag.name.split(" Only").join("").split("&").join("")
                          );
                          // console.log(tagProfession, queryParams.profession);
                          return queryParams.profession.includes(tagProfession);
                        })
                      );
                    }
                    return !!album.tags.find((tag) => tag.name === category);
                  }),
                }))
                .filter((categoryAlbums) => categoryAlbums.albums.length > 0);

              return (
                <Fragment>
                  {categoryAlbums.map(
                    ({ albums, category: categoryLabel }, index) => {
                      // if (albums.length === 0) return null
                      const category = categoryLabel.split(" Only").join("");
                      const slides = albums
                        .sort((a, b) => b.order - a.order)
                        .map((album) => {
                          const to =
                            1 === 1
                              ? `${props.category ? `../` : ``}${friendlyUrl(
                                  category || "loading"
                                )}/${friendlyUrl(
                                  album.title.split(" - ")[1] || "nothing"
                                )}${
                                  !!queryParams.profession
                                    ? `?profession=${queryParams.profession}`
                                    : ""
                                }`
                              : `${friendlyUrl(album.title.split(" - ")[1])}${
                                  !!queryParams.profession
                                    ? `?profession=${queryParams.profession}`
                                    : ""
                                }`;
                          return album.slides.length > 0
                            ? {
                                ...album.slides[0],
                                to,
                                albumTitle: album.title.split(" - ")[1],
                                profession: getProfessions(album.tags).join(
                                  " - "
                                ),
                                keyValues: album.keyValues,
                              }
                            : {
                                to,
                                albumTitle: album.title.split(" - ")[1],
                                profession: getProfessions(album.tags).join(
                                  " - "
                                ),
                              };
                        });
                      return (
                        <Section
                          key={friendlyUrl(category)}
                          setInView={(value) =>
                            setInView({
                              ...inView,
                              [friendlyUrl(category)]: value,
                            })
                          }
                          id={friendlyUrl(category)}
                        >
                          {props.category !== "bio" && (
                            <Fragment>
                              {index > 0 && <Divider mb={6} />}
                              <ArtistProjectOverview slides={slides} />
                            </Fragment>
                          )}
                        </Section>
                      );
                    }
                  )}
                  <Section
                    setInView={(value) => setInView({ ...inView, bio: value })}
                    id="bio"
                  >
                    <Helmet>
                      <title>
                        {artistTagName.split("Volkers").join("Völkers")} -{" "}
                        {profession ? profession.join(" - ") : null} • House Of
                        Orange Agency • Amsterdam
                      </title>
                      <meta
                        name="og:title"
                        content={`${artistTagName
                          .split("Volkers")
                          .join(
                            "Völkers"
                          )} • House Of Orange Agency • Amsterdam`}
                      />
                    </Helmet>
                    <Bio
                      artist={props.artist}
                      name={artistTagName.split("Volkers").join("Völkers")}
                      profession={profession ? profession.join(" - ") : null}
                    />
                  </Section>
                  <ScrollToSectionIfNeeded key={props.artist} />
                </Fragment>
              );
            }}
          </Query>
        )}

        <Footer isWide={props.isWide} />
      </View>
    </Fragment>
  );
}

const ScrollToSectionIfNeeded = () => {
  useLayoutEffect(() => {
    const hash = getHash();
    console.log(hash);
    if (hash && hash.length > 1) {
      const id = hash;
      const $anchor = document.getElementById(id);
      if ($anchor) {
        const offsetTop =
          $anchor.getBoundingClientRect().top + window.pageYOffset;
        setTimeout(
          () =>
            window.scroll({
              top: offsetTop - offset,
              behavior: "smooth",
            }),
          600
        );
      }
      removeHash();
    }
  }, []);
  return null;
};
/*

                  }}
                </Categories>
                <Bio artist={props.artist} />
              </Fragment>

              */

export default compose(
  graphql(albumQuery, {
    options: ({ artist }) => {
      return {
        fetchPolicy: "cache-and-network",
        variables: {
          user: process.env.REACT_APP_WHITESPACE_USER,
          slug: artist ? `${artist}-bio` : "not-found",
        },
      };
    },
  })
)(Artist);

const Section = ({ id, setInView, children }) => {
  const ref = useRef();
  const onScreen = useOnScreen(ref);
  useEffect(() => {
    setInView(onScreen);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onScreen]);
  return (
    <section id={id} ref={ref}>
      {children}
    </section>
  );
};

// Hook
const useOnScreen = (ref, rootMargin = "-160px") => {
  // State and setter for storing whether element is visible
  const [isIntersecting, setIntersecting] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // Update our state when observer callback fires
        setIntersecting(entry.isIntersecting);
      },
      {
        rootMargin,
      }
    );
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => {
      observer.unobserve(ref.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty array ensures that effect is only run on mount and unmount

  return isIntersecting;
};

export const CategoriesMenu = ({
  artistTagName,
  Header = ({ children }) => children,
  props,
  profession,
  inView,
  albumData,
  albumCategory,
  queryParams,
}) => {
  const whereWasI = React.useMemo(
    () => sessionStorage.getItem("whereWasI"),
    []
  );

  return (
    <Query
      query={tagAlbumsQuery}
      fetchPolicy="cache-and-network"
      variables={{
        user: process.env.REACT_APP_WHITESPACE_USER,
        tagName: artistTagName,
      }}
    >
      {({ loading, error, data }) => {
        if (loading && !data?.allTags)
          return !props.isWide ? null : (
            <Header>
              <CategoryItemsContainer>
                {/* <CategoryNav /> */}
                <View mt={!albumCategory ? 2 : 0} style={{ flex: 1 }} pt={2}>
                  <Text>&nbsp;</Text>
                </View>
                {!albumCategory && (
                  <View mt={2} style={{ flex: 0 }} pt={2}>
                    <Link to="/contact" ml={3}>
                      Contact Agent
                    </Link>
                  </View>
                )}
              </CategoryItemsContainer>
              {!albumCategory && <Divider mt={2} mb={4} />}
            </Header>
          );
        if (error && !data.allTags)
          return <Text>{`Error! ${error.message}`}</Text>;
        const albums = data.allTags[0]?.albums;
        if (!albums) return <Text>..no albums</Text>;
        const categoryAlbums = categoriesProjects
          .map((category) => ({
            category,
            albums: albums.filter((album) => {
              // when a profession is specified as search param, only display those albums...
              // or maybe just reorder them to the top?
              if (!!queryParams?.profession) {
                return (
                  !!album.tags.find((tag) => tag.name === category) &&
                  album.tags.find((tag) => {
                    const tagProfession = friendlyUrl(
                      tag.name.split(" Only").join("").split("&").join("")
                    );
                    // console.log(tagProfession, queryParams.profession);
                    return queryParams.profession.includes(tagProfession);
                  })
                );
              }
              return album.tags.find((tag) => tag.name === category);
            }),
          }))
          .filter((categoryAlbums) => categoryAlbums.albums.length > 0);
        if (!props.isWide && !albumCategory)
          return (
            <Fragment>
              <MobileHeader
                fixed="fixed"
                items={[
                  ...categoryAlbums
                    .map((albums, index) => {
                      if (albums.albums.length === 0) return null;
                      const category = albums.category.split(" Only").join("");
                      return {
                        href: `${
                          queryParams.profession
                            ? `/artists/${friendlyUrl(artistTagName || "any")}`
                            : ""
                        }#${friendlyUrl(category)}`, // TODO: fix
                        label: category,
                        as: AnchorLink,
                        offset: index > 0 ? 190 : 190,
                        active:
                          albumCategory === category ||
                          (inView && inView[friendlyUrl(category)]),
                      };
                    })
                    .filter((item) => item),
                  {
                    href: `#bio`,
                    label: "Bio",
                    as: AnchorLink,
                    offset: 190,
                    active: inView && inView["bio"],
                  },
                ]}
              >
                <Text textStyle={"headline"} mt={4}>
                  {artistTagName}
                </Text>
              </MobileHeader>
              <View
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
                mb={1}
              >
                <Text textStyle="caption" mb={2}>
                  {profession &&
                    profession.map((p, index) => (
                      <Fragment>
                        {p}
                        {index < profession.length - 1 && ` - `}
                      </Fragment>
                    ))}
                </Text>
                <Link invert to="/contact" mb={2} textStyle="caption">
                  Contact Agent
                </Link>
              </View>
            </Fragment>
          );

        return (
          <Header>
            <CategoryItemsContainer>
              {/* <CategoryNav /> */}

              <View
                mt={!albumCategory ? 2 : 0}
                style={{ flex: 1 }}
                pt={!albumCategory ? 2 : 1}
              >
                {categoryAlbums.map((albums, index) => {
                  if (albums.albums.length === 0) return null;

                  const category = albums.category.split(" Only").join("");

                  return (
                    <Link
                      as={albumCategory ? undefined : AnchorLink}
                      offset={index > 0 ? offset : 150}
                      key={category}
                      href={albumCategory ? null : `#${friendlyUrl(category)}`}
                      to={
                        albumCategory
                          ? `/artist/${friendlyUrl(artistTagName || "any")}${
                              queryParams.profession
                                ? `?profession=${queryParams.profession}`
                                : ""
                            }#${friendlyUrl(category)}`
                          : null
                      }
                      mr={0}
                      mt={2}
                      style={{
                        ...((albumCategory === category.toLowerCase() ||
                          (inView && inView[friendlyUrl(category)])) && {
                          color: "black",
                        }),
                      }}
                      back={
                        albumCategory === category.toLowerCase() &&
                        whereWasI !== "home"
                      }
                    >
                      {category}
                      {index < categoryAlbums.length - 1 ||
                      (index === categoryAlbums.length - 1 &&
                        albumData?.description !== null)
                        ? " / "
                        : ""}
                    </Link>
                  );
                })}
                {!!albumData?.description && (
                  <Link
                    as={!albumCategory && AnchorLink}
                    offset={offset}
                    href={albumCategory ? undefined : "#bio"}
                    to={
                      albumCategory
                        ? `/artist/${friendlyUrl(artistTagName || "any")}${
                            queryParams.profession
                              ? `?profession=${queryParams.profession}`
                              : ""
                          }#bio`
                        : undefined
                    }
                    mt={2}
                    ml={0}
                    style={{
                      ...(inView &&
                        inView["bio"] && {
                          color: "black",
                        }),
                    }}
                  >
                    Bio
                  </Link>
                )}
              </View>
              {!albumCategory && (
                <View mt={2} style={{ flex: 0 }} pt={2}>
                  <Link to="/contact" ml={3}>
                    Contact Agent
                  </Link>
                </View>
              )}
            </CategoryItemsContainer>
            {!albumCategory && <Divider mt={2} mb={4} />}
          </Header>
        );
      }}
    </Query>
  );
};
